import React from 'react';

const Card = (props) => {

    return (
        <div className="projectDashboard" style={{ background: props?.bg }}>
            <h2>
                {props?.formsCount}
            </h2>
            <h4>
                {props?.type}
            </h4>
        </div>
    );
}

export default Card;
